export default __webpack_public_path__ + "static/media/image-slider03.1232b29c.jpg";